module.exports = __webpack_public_path__ + "static/39th-fb625c2685467edb786148c9aca17585.png";